module.exports = "https://static.im-cdn.com/mjc/storefront/Comfort/static/media/minus.6e4e80b1.svg";